import React from 'react';
import {TextField} from '@material-ui/core';
import {SuccessBlueIcon} from '../Icons/Icons'
import $ from 'jquery';
import './TextFieldInput.scss';

const passwordReset = (history) => <span className='password-link' onClick={() => history.push('/password_recovery')}>restore</span>;

const TextFieldInput = ({
                            name, label, id = null, value, handleChange, required = false, classes, shrink, placeholder = '',
                            multiline = false, rows = 1, type = 'string', disabled = false, endAdornment, error = false, history = false,
                            onFocusOut = false, hint = false, isValidRule = false, parentClasses = false
                        }) => (
    <div className={ !parentClasses ? '' : parentClasses }>
        <TextField
            onFocus={(e) => $(e.target).closest('.textfield-root').addClass('focused-field')}
            onBlur={(e) => {
                $(e.target).closest('.textfield-root').removeClass('focused-field')
                if (onFocusOut) onFocusOut();
            }}
            classes={{
                root: `textfield-root ${classes} ${disabled && 'disabled-root'} ${error && 'error'}`
            }}
            id={id !== null ? id : name}
            name={name}
            label={label + (!required ? ' (optional)' : '')}
            InputProps={{
                disableUnderline: true,
                classes: {
                    root: 'input-root',
                    disabled: 'input-disabled'
                },
                ...endAdornment
            }}
            InputLabelProps={{
                classes: {
                    root: 'input-label',
                    shrink: 'shrinked'
                },
                ...shrink
            }}
            multiline={multiline}
            rows={rows}
            value={value}
            onChange={handleChange}
            margin="dense"
            placeholder={placeholder}
            type={type}
            disabled={disabled}
            onClick={() => id !== null ? $(`#${id}`).focus() : $(`#${name}`).focus()}
        />
        {typeof error === 'string' ? <div className="error-text">
            {error === 'email-exist' ? <div>This email address is already registered. Please choose another email or you
                can {passwordReset(history)} your password</div> : error}
        </div> : ''}
        {(hint && typeof error !== 'string') && <div className="hint-text">
            {(hint && isValidRule) && <SuccessBlueIcon/>}
            <div>{hint}</div>
        </div>}
    </div>
);

export default TextFieldInput;


// WEBPACK FOOTER //
// ./src/components/Common/TextFieldInput/TextFieldInput.js